import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { eventKey as t } from "../../core/events.js";
import { init as i } from "../../core/watchUtils.js";
import { aliasOf as r } from "../../core/accessorSupport/decorators/aliasOf.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { property as a } from "../../core/accessorSupport/decorators/property.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import s from "../Widget.js";
import n from "./FeatureMedia/FeatureMediaViewModel.js";
import l from "./support/FeatureElementInfo.js";
import { shouldOpenInNewTab as d } from "./support/featureUtils.js";
import { loadChartsModule as c, getColorSet as m } from "../support/chartUtils.js";
import { isDarkTheme as u, isRTL as h } from "../support/widgetUtils.js";
import { messageBundle as p } from "../support/decorators/messageBundle.js";
import "../../core/Logger.js";
import { tsx as f } from "../support/jsxFactory.js";
var v = {
  base: "esri-feature-media",
  mediaContainer: "esri-feature-media__container",
  mediaItemContainer: "esri-feature-media__item-container",
  mediaItem: "esri-feature-media__item",
  mediaItemTitle: "esri-feature-media__item-title",
  mediaItemCaption: "esri-feature-media__item-caption",
  mediaPrevious: "esri-feature-media__previous",
  mediaPreviousIconLTR: "esri-feature-media__previous-icon",
  mediaPreviousIconRTL: "esri-feature-media__previous-icon--rtl",
  mediaNext: "esri-feature-media__next",
  mediaNextIconLTR: "esri-feature-media__next-icon",
  mediaNextIconRTL: "esri-feature-media__next-icon--rtl",
  mediaChart: "esri-feature-media__chart",
  mediaButton: "esri-feature-media__button",
  mediaIcon: "esri-feature-media__icon",
  iconLeftTriangleArrow: "esri-icon-left-triangle-arrow",
  iconRightTriangleArrow: "esri-icon-right-triangle-arrow"
},
    _ = .05,
    I = .95,
    M = 15;

var w = /*#__PURE__*/function (_s) {
  _inherits(w, _s);

  var _super = _createSuper(w);

  function w(e, t) {
    var _this;

    _classCallCheck(this, w);

    _this = _super.call(this, e, t), _this._refreshTimer = null, _this._refreshIntervalInfo = null, _this._featureElementInfo = null, _this.attributes = null, _this.activeMediaInfoIndex = null, _this.description = null, _this.fieldInfoMap = null, _this.layer = null, _this.mediaInfos = null, _this.popupTemplate = null, _this.relatedInfos = null, _this.title = null, _this.viewModel = new n(), _this.messages = null, _this._getChartDependencies = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var t, _assertThisInitialize, i, r;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return c();

              case 2:
                t = _context.sent;
                _assertThisInitialize = _assertThisInitialized(_this);
                i = _assertThisInitialize.viewModel;

                if (i) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                r = i.activeMediaInfo;

                _this._renderChart({
                  chartDiv: e,
                  mediaInfo: r,
                  chartsModule: t
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return _this;
  }

  _createClass(w, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this._featureElementInfo = new l(), this.own(i(this, ["viewModel.activeMediaInfo", "viewModel.activeMediaInfoIndex"], function () {
        return _this2._setupMediaRefreshTimer();
      }), i(this, ["viewModel.description", "viewModel.title"], function () {
        return _this2._setupFeatureElementInfo();
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._clearMediaRefreshTimer(), this._featureElementInfo.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var e;
      return f("div", {
        bind: this,
        class: v.base,
        onkeyup: this._handleMediaKeyup
      }, null == (e = this._featureElementInfo) ? void 0 : e.render(), this.renderMedia());
    }
  }, {
    key: "renderMedia",
    value: function renderMedia() {
      var e = this.viewModel.formattedMediaInfoCount;
      return e ? f("div", {
        key: "media-element-container",
        class: v.mediaContainer
      }, this.renderMediaPageButton("previous"), this.renderMediaInfo(), this.renderMediaPageButton("next")) : null;
    }
  }, {
    key: "renderImageMediaInfo",
    value: function renderImageMediaInfo(e) {
      var t = this._refreshIntervalInfo,
          _this$viewModel = this.viewModel,
          i = _this$viewModel.activeMediaInfoIndex,
          r = _this$viewModel.formattedMediaInfoCount,
          a = e.value,
          o = e.refreshInterval,
          s = e.altText,
          n = e.title,
          l = e.type,
          c = a.sourceURL,
          m = a.linkURL,
          u = d(m) ? "_blank" : "_self",
          h = "_blank" === u ? "noreferrer" : "",
          p = o ? t : null,
          v = p ? p.timestamp : 0,
          _ = p ? p.sourceURL : c,
          I = f("img", {
        alt: s || n,
        key: "media-".concat(l, "-").concat(i, "-").concat(r, "-").concat(v),
        src: _
      }),
          M = m ? f("a", {
        title: n,
        href: m,
        rel: h,
        target: u
      }, I) : null;

      return M || I;
    }
  }, {
    key: "renderChartMediaInfo",
    value: function renderChartMediaInfo(e) {
      var _this$viewModel2 = this.viewModel,
          t = _this$viewModel2.activeMediaInfoIndex,
          i = _this$viewModel2.formattedMediaInfoCount;
      return f("div", {
        key: "media-".concat(e.type, "-").concat(t, "-").concat(i),
        bind: this,
        class: v.mediaChart,
        afterCreate: this._getChartDependencies
      });
    }
  }, {
    key: "renderMediaInfoType",
    value: function renderMediaInfoType() {
      var e = this.viewModel.activeMediaInfo;
      return e ? "image" === e.type ? this.renderImageMediaInfo(e) : -1 !== e.type.indexOf("chart") ? this.renderChartMediaInfo(e) : null : null;
    }
  }, {
    key: "renderMediaInfo",
    value: function renderMediaInfo() {
      var e = this.viewModel.activeMediaInfo;
      if (!e) return null;
      var t = e.title ? f("div", {
        key: "media-title",
        class: v.mediaItemTitle,
        innerHTML: e.title
      }) : null,
          i = e.caption ? f("div", {
        key: "media-caption",
        class: v.mediaItemCaption,
        innerHTML: e.caption
      }) : null;
      return f("div", {
        key: "media-container",
        class: v.mediaItemContainer
      }, f("div", {
        key: "media-item-container",
        class: v.mediaItem
      }, this.renderMediaInfoType()), t, i);
    }
  }, {
    key: "renderMediaPageButton",
    value: function renderMediaPageButton(e) {
      if (this.viewModel.formattedMediaInfoCount < 2) return null;
      var t = "previous" === e,
          i = t ? this.messages.previous : this.messages.next,
          r = t ? this.classes(v.mediaButton, v.mediaPrevious) : this.classes(v.mediaButton, v.mediaNext),
          a = t ? this.classes(v.mediaIcon, v.mediaPreviousIconLTR, v.iconLeftTriangleArrow) : this.classes(v.mediaIcon, v.mediaNextIconLTR, v.iconRightTriangleArrow),
          o = t ? this.classes(v.mediaIcon, v.mediaPreviousIconRTL, v.iconRightTriangleArrow) : this.classes(v.mediaIcon, v.mediaNextIconRTL, v.iconLeftTriangleArrow),
          s = t ? "media-previous" : "media-next",
          n = t ? this._previous : this._next;
      return f("button", {
        type: "button",
        key: s,
        title: i,
        "aria-label": i,
        tabIndex: 0,
        class: r,
        bind: this,
        onclick: n
      }, f("span", {
        "aria-hidden": "true",
        class: a
      }), f("span", {
        "aria-hidden": "true",
        class: o
      }));
    }
  }, {
    key: "_setupFeatureElementInfo",
    value: function _setupFeatureElementInfo() {
      var e = this.description,
          t = this.title;

      this._featureElementInfo.set({
        description: e,
        title: t
      });
    }
  }, {
    key: "_next",
    value: function _next() {
      this.viewModel.next();
    }
  }, {
    key: "_previous",
    value: function _previous() {
      this.viewModel.previous();
    }
  }, {
    key: "_handleMediaKeyup",
    value: function _handleMediaKeyup(e) {
      var i = t(e);
      "ArrowLeft" === i && (e.stopPropagation(), this.viewModel.previous()), "ArrowRight" === i && (e.stopPropagation(), this.viewModel.next());
    }
  }, {
    key: "_renderChart",
    value: function _renderChart(e) {
      var t = e.chartsModule,
          i = e.chartDiv,
          r = e.mediaInfo,
          a = r.value,
          o = r.type,
          s = t.am4core,
          n = m(s);

      function l(e) {
        e instanceof s.ColorSet && n && (e.list = n);
      }

      u() && s.useTheme(t.am4themes_dark), s.useTheme(t.am4themes_animated), s.useTheme(l);
      var d = "pie-chart" === o ? this._createPieChart(e) : this._createXYChart(e);
      i.setAttribute("aria-label", r.altText || r.title), d.data = a.series.map(function (e) {
        return {
          tooltip: e.tooltip,
          value: e.value
        };
      }).filter(function (e) {
        return "pie-chart" !== o || e.value > 0;
      });
    }
  }, {
    key: "_customizeChartTooltip",
    value: function _customizeChartTooltip(e, t) {
      e.label.wrap = !0, e.label.maxWidth = 200, e.autoTextColor = !1, e.getFillFromObject = !1, e.label.fill = t.color("#ffffff"), e.background.fill = t.color({
        r: 0,
        g: 0,
        b: 0,
        a: .7
      });
    }
  }, {
    key: "_createPieChart",
    value: function _createPieChart(e) {
      var t = e.chartDiv,
          i = e.chartsModule,
          r = i.am4core,
          a = i.am4charts,
          o = r.create(t, a.PieChart);
      o.rtl = h(this.container);
      var s = o.series.push(new a.PieSeries());
      return s.labels.template.disabled = !0, s.ticks.template.disabled = !0, s.dataFields.value = "value", s.dataFields.category = "tooltip", this._customizeChartTooltip(s.tooltip, r), o;
    }
  }, {
    key: "_getMinSeriesValue",
    value: function _getMinSeriesValue(e) {
      var t = 0;
      return e.forEach(function (e) {
        return t = Math.min(e.value, t);
      }), t;
    }
  }, {
    key: "_createColumnChart",
    value: function _createColumnChart(e, t) {
      var i = t.chartsModule,
          r = t.mediaInfo,
          a = r.value,
          o = i.am4core,
          s = i.am4charts,
          n = e.xAxes.push(new s.CategoryAxis());
      n.dataFields.category = "tooltip", n.renderer.labels.template.disabled = !0, this._customizeChartTooltip(n.tooltip, o), n.tooltip.events.on("sizechanged", function () {
        n.tooltip.dy = -n.tooltip.contentHeight;
      });
      var l = e.yAxes.push(new s.ValueAxis()),
          d = l.renderer.labels.template;
      l.renderer.minLabelPosition = _, l.renderer.maxLabelPosition = I, l.min = this._getMinSeriesValue(a.series), this._customizeChartTooltip(l.tooltip, o), d.wrap = !0;
      var c = e.series.push(new s.ColumnSeries());
      c.dataFields.valueY = "value", c.dataFields.categoryX = "tooltip", e.cursor = new s.XYCursor(), a.series.length > M && (e.scrollbarX = new o.Scrollbar());
    }
  }, {
    key: "_createBarChart",
    value: function _createBarChart(e, t) {
      var i = t.chartsModule,
          r = t.mediaInfo,
          a = r.value,
          o = i.am4core,
          s = i.am4charts,
          n = e.yAxes.push(new s.CategoryAxis());
      n.dataFields.category = "tooltip", n.renderer.inversed = !0, n.renderer.labels.template.disabled = !0, this._customizeChartTooltip(n.tooltip, o), n.tooltip.events.on("sizechanged", function () {
        n.tooltip.dx = n.tooltip.contentWidth;
      });
      var l = e.xAxes.push(new s.ValueAxis()),
          d = l.renderer.labels.template;
      l.renderer.minLabelPosition = _, l.renderer.maxLabelPosition = I, l.min = this._getMinSeriesValue(a.series), this._customizeChartTooltip(l.tooltip, o), d.wrap = !0;
      var c = e.series.push(new s.ColumnSeries());
      c.dataFields.valueX = "value", c.dataFields.categoryY = "tooltip", e.cursor = new s.XYCursor(), a.series.length > M && (e.scrollbarY = new o.Scrollbar());
    }
  }, {
    key: "_createLineChart",
    value: function _createLineChart(e, t) {
      var i = t.chartsModule,
          r = t.mediaInfo,
          a = r.value,
          o = i.am4core,
          s = i.am4charts,
          n = e.xAxes.push(new s.CategoryAxis());
      n.dataFields.category = "tooltip", n.renderer.labels.template.disabled = !0, this._customizeChartTooltip(n.tooltip, o), n.tooltip.events.on("sizechanged", function () {
        n.tooltip.dy = -n.tooltip.contentHeight;
      });
      var l = e.yAxes.push(new s.ValueAxis()),
          d = l.renderer.labels.template;
      l.renderer.minLabelPosition = _, l.renderer.maxLabelPosition = I, l.min = this._getMinSeriesValue(a.series), this._customizeChartTooltip(l.tooltip, o), d.wrap = !0;
      var c = e.series.push(new s.LineSeries());
      c.dataFields.categoryX = "tooltip", c.dataFields.valueY = "value", e.cursor = new s.XYCursor(), a.series.length > M && (e.scrollbarX = new o.Scrollbar());
    }
  }, {
    key: "_createXYChart",
    value: function _createXYChart(e) {
      var t = e.chartDiv,
          i = e.chartsModule,
          r = e.mediaInfo,
          a = r.type,
          o = i.am4core,
          s = i.am4charts,
          n = o.create(t, s.XYChart);
      return n.rtl = h(this.container), "column-chart" === a && this._createColumnChart(n, e), "bar-chart" === a && this._createBarChart(n, e), "line-chart" === a && this._createLineChart(n, e), n;
    }
  }, {
    key: "_clearMediaRefreshTimer",
    value: function _clearMediaRefreshTimer() {
      var e = this._refreshTimer;
      e && (clearTimeout(e), this._refreshTimer = null);
    }
  }, {
    key: "_updateMediaInfoTimestamp",
    value: function _updateMediaInfoTimestamp(e) {
      var t = Date.now();
      this._refreshIntervalInfo = {
        timestamp: t,
        sourceURL: this._getImageSource(e, t)
      }, this.scheduleRender();
    }
  }, {
    key: "_setupMediaRefreshTimer",
    value: function _setupMediaRefreshTimer() {
      this._clearMediaRefreshTimer();

      var e = this.viewModel.activeMediaInfo;
      e && "image" === e.type && e.refreshInterval && this._setRefreshTimeout(e);
    }
  }, {
    key: "_setRefreshTimeout",
    value: function _setRefreshTimeout(e) {
      var _this3 = this;

      var t = e.refreshInterval,
          i = e.value;
      if (!t) return;
      var r = 6e4 * t;

      this._updateMediaInfoTimestamp(i.sourceURL);

      var a = setInterval(function () {
        _this3._updateMediaInfoTimestamp(i.sourceURL);
      }, r);
      this._refreshTimer = a;
    }
  }, {
    key: "_getImageSource",
    value: function _getImageSource(e, t) {
      var i = -1 !== e.indexOf("?") ? "&" : "?",
          _e$split = e.split("#"),
          _e$split2 = _slicedToArray(_e$split, 2),
          r = _e$split2[0],
          _e$split2$ = _e$split2[1],
          a = _e$split2$ === void 0 ? "" : _e$split2$;

      return "".concat(r).concat(i, "timestamp=").concat(t).concat(a ? "#" : "").concat(a);
    }
  }]);

  return w;
}(s);

e([r("viewModel.attributes")], w.prototype, "attributes", void 0), e([r("viewModel.activeMediaInfoIndex")], w.prototype, "activeMediaInfoIndex", void 0), e([r("viewModel.description")], w.prototype, "description", void 0), e([r("viewModel.fieldInfoMap")], w.prototype, "fieldInfoMap", void 0), e([r("viewModel.layer")], w.prototype, "layer", void 0), e([r("viewModel.mediaInfos")], w.prototype, "mediaInfos", void 0), e([r("viewModel.popupTemplate")], w.prototype, "popupTemplate", void 0), e([r("viewModel.relatedInfos")], w.prototype, "relatedInfos", void 0), e([r("viewModel.title")], w.prototype, "title", void 0), e([a({
  type: n
})], w.prototype, "viewModel", void 0), e([a(), p("esri/widgets/Feature/t9n/Feature")], w.prototype, "messages", void 0), w = e([o("esri.widgets.Feature.FeatureMedia")], w);
var g = w;
export { g as default };